import { Outlet, RouteObject } from "react-router";

import ErrorScreen from "../app/screens/ErrorScreen";
import { invoicesRoutes } from "../invoices/routes";
import { projectRoutes } from "../project/routes";
import ProjectCreateScreen from "../project/screens/ProjectCreateScreen";
import ProjectListScreen from "../project/screens/ProjectListScreen";
import { protocolRoutes } from "../settings/protocol/routes";
import RequiredClient from "./components/RequireClient";
import ClientCreateScreen from "./screens/ClientCreateScreen";
import { ClientExportCreateScreen } from "./screens/ClientExportCreateScreen";
import { ClientExportListScreen } from "./screens/ClientExportListScreen";
import ClientListScreen from "./screens/ClientListScreen";
import ClientUpdateScreen from "./screens/ClientUpdateScreen";
import ClientUserCreateScreen from "./screens/ClientUserCreateScreen";
import ClientUserListScreen from "./screens/ClientUserListScreen";
import { ClientVisitListScreen } from "./screens/ClientVisitListScreen";

export const clientsRoutes: RouteObject[] = [
    {
        path: "clients",
        handle: { breadcrumb: "client:clientListScreen.title" },
        children: [
            {
                index: true,
                element: <ClientListScreen />,
            },
            {
                path: "new",
                element: <ClientCreateScreen />,
                handle: { breadcrumb: "client:clientCreateScreen.title" },
            },
        ],
    },
];

export const clientRoutes: RouteObject[] = [
    {
        path: "c/:clientSlug",
        element: (
            <RequiredClient>
                <Outlet />
            </RequiredClient>
        ),
        children: [
            {
                handle: { breadcrumb: "client:clientMenu.projects" },
                children: [
                    {
                        index: true,
                        element: <ProjectListScreen />,
                    },
                    {
                        handle: { breadcrumb: "project:projectCreateScreen.title" },
                        path: "new-project",
                        element: <ProjectCreateScreen />,
                    },
                ],
            },
            { handle: { breadcrumb: "client:clientMenu.settings" }, path: "settings", element: <ClientUpdateScreen /> },
            {
                handle: { breadcrumb: "client:clientMenu.planned" },
                path: "planned",
                element: <ClientVisitListScreen />,
            },
            ...protocolRoutes,
            ...projectRoutes,
            ...invoicesRoutes,
            {
                path: "users",
                handle: {
                    breadcrumb: "user:userListScreen.title",
                },
                children: [
                    {
                        index: true,
                        element: <ClientUserListScreen />,
                    },
                    {
                        path: "new",
                        element: <ClientUserCreateScreen />,
                        handle: { breadcrumb: "user:userCreateScreen.title" },
                    },
                ],
            },
            {
                path: "export",
                handle: { breadcrumb: "projectExport:ProjectExportListScreen.title" },
                children: [
                    { index: true, element: <ClientExportListScreen /> },
                    {
                        path: "create",
                        handle: { breadcrumb: "projectExport:ProjectExportCreateScreen.title" },
                        element: <ClientExportCreateScreen />,
                    },
                ],
            },
            {
                path: "*",
                handle: { breadcrumb: () => "Error" },
                element: <ErrorScreen error={new Error("Reached navigation error route.")} />,
            },
        ],
    },
];
